module.exports = __webpack_public_path__ + "static/media/mongo.39317dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mongo.png
// module id = 166
// module chunks = 0